import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'

function Jobs() {
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Jobs" />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">     
                        <div className='col-md-12'>
                            <h2>Coming Soon..</h2>
                        </div>  
                    </div>    
                    
                </div>
            </section>
        </>
    )
}

export default Jobs